export default "__VITE_ASSET__Cv$93och__"